import { render, staticRenderFns } from "./AddOrEditServicePointForm.vue?vue&type=template&id=e52b87dc"
import script from "./AddOrEditServicePointForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditServicePointForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditServicePointForm.vue?vue&type=style&index=0&id=e52b87dc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports